import { render, staticRenderFns } from "./EmployersLiabilityComponent.vue?vue&type=template&id=14107cbf&scoped=true&"
import script from "./EmployersLiabilityComponent.vue?vue&type=script&lang=js&"
export * from "./EmployersLiabilityComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14107cbf",
  null
  
)

export default component.exports